import "./styles.scss"

const Btn = ({ children, funOnclick, id="", type="btn_1", nombre="", disable=false}) => {
    return (
        <button onClick={funOnclick} className={type} id={id} name={nombre} disabled={disable}>
            {children}
        </button>
    )
}

export default Btn
